import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Landing from './Landing.js';
import About from './About.js';
import Projects from './Projects.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import { setNavigate, updatePageColors } from './helpers/Helpers.js';
import './Header.css'; // For safe area styles

// Component to manage navigation and colors
function AppManager() {
  const navigate = useNavigate();
  const location = useLocation();
  const safeTopRef = useRef(null);
  const safeBottomRef = useRef(null);
  
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    // Update all colors when location changes
    updatePageColors(location.pathname);
    
    // Also directly set colors on refs after a brief delay to ensure DOM is ready
    const timeoutId = setTimeout(() => {
      if (safeTopRef.current && safeBottomRef.current) {
        const colors = {
          '/': { safeTop: '#704E2E', safeBottom: '#704E2E' },
          '/about': { safeTop: '#D9D9D9', safeBottom: '#75B9BE' },
          '/projects': { safeTop: '#330036', safeBottom: '#330036' },
          '/shaker/privacy-policy': { safeTop: '#D9D9D9', safeBottom: '#D9D9D9' },
        }[location.pathname] || { safeTop: '#000000', safeBottom: '#000000' };
        
        safeTopRef.current.style.setProperty('background-color', colors.safeTop, 'important');
        safeBottomRef.current.style.setProperty('background-color', colors.safeBottom, 'important');
      }
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);
  
  return (
    <>
      {/* Safe area elements - colors set via JS in updatePageColors and refs */}
      <div id="safe-area-top" ref={safeTopRef} />
      <div id="safe-area-bottom" ref={safeBottomRef} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppManager />
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/about' element={<About />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/shaker/privacy-policy' element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
